<template>
    <div class="date-picker-input">
        <icon name="calendar" scale="0.9" class="calendar-icon"></icon>
        <input autocomplete="off" type="text" v-model="dateVal" @focusout="onKeyUp" style="font-family:Arial,sans-serif" />
    </div>
</template>

<script>

    export default {

        props: {
            value: {
                type: Date,
                required: false
            },
            minDate: {
                type: Date,
                default() {
                    return new Date(2010, 0, 1);
                }
            },
            maxDate: {
                type: Date,
                default() {
                    return new Date();
                }
            }
        },

        data() {
            return {
                dateVal: null,
                lastDateVal: null
            };
        },

        created() {
            this.dateVal = this.lastDateVal = this.parseDate(this.value);
        },

        watch: {
            value(val) {
                this.dateVal = this.lastDateVal = this.parseDate(this.value);
            }
        },

        methods: {

            parseNumber(number) {

                if (number.toString().length == 1)
                    return `0${number}`;

                if (number.toString().length > 2)
                    return number.toString().substring(number.toString().length - 2, number.toString().length);

                return number;
            },

            parseDate(val) {
                if (val)
                    return `${this.parseNumber(val.getDate())}/${this.parseNumber(val.getMonth() + 1)}/${val.getFullYear()}`;
            },

            onKeyUp(e) {

                var val = e.target.value;

                var arr = val.split('/');
                if (arr.length != 3) {
                    this.dateVal = this.lastDateVal;
                    return;
                }

                var day = arr[0];
                var month = arr[1];
                var year = arr[2];
                var date = `${month}/${day}/${year}`;
                var parsedDate = Date.parse(date);
                if (isNaN(parsedDate)) {
                    this.dateVal = this.lastDateVal;
                    return;
                }

                if (this.minDate) {
                    if (parsedDate < this.minDate) {
                        this.dateVal = this.lastDateVal;
                        return;
                    }
                }

                if (this.maxDate) {
                    if (parsedDate > this.maxDate) {
                        this.dateVal = this.lastDateVal;
                        return;
                    }
                }

                this.dateVal = this.lastDateVal = this.parseDate(new Date(parsedDate));

                let d = new Date();
                let minutes = d.getMinutes();
                let seconds = d.getSeconds();
                let hours = d.getHours();

                let _date = new Date(parsedDate);
                _date = new Date(_date.setHours(hours, minutes, seconds));

                this.$emit('input', _date);
            }

        }

    }

</script>

<style lang="scss" scoped>

    .date-picker-input {
        height: 32px;
        outline: none;
        border: 1px solid #ddd;
        cursor: default;
        display: flex;
        align-items: center;
        padding-left: 15px;
        border-radius: 3px;
        width: 190px;
        .calendar-icon

    {
        color: #706f6f;
    }

    input {
        height: 26px;
        outline-width: 0;
        font-size: 14px;
        color: #706f6f;
        border: 0;
        margin-left: 10px;
        background: white;
        width: 90%;
    }
    }
</style>



// WEBPACK FOOTER //
// src/components/Common/RangedDatePicker/DatePickerInput.vue